import {Button, YStack} from "@chayka/ui";
import {BottomSheet} from "../layout";

interface ContactFormBottomSheetProps {
  isOpen: boolean;
  onClose: () => void;
}

const handleContactClick = () => {
  window.open("mailto:makustova.chayka+support@gmail.com", "_blank");
};

export const ContactFormBottomSheet: React.FC<ContactFormBottomSheetProps> = ({
  isOpen,
  onClose,
}) => {
  return (
    <BottomSheet fullHeight isOpen={isOpen} onClose={onClose}>
      <YStack className="h-full justify-center items-center gap-10">
        <h1 className="text-3xl font-light text-center">Нам важно, чтобы вам было комфортно!</h1>
        <div className="text-secondary-text text-sm text-center">
          Если вы заметили какую-то ошибку, неисправность, или у вас появилась идея, как можно
          улучшить приложение – обязательно напишите нам, и мы изучим ваш вопрос!
        </div>
        <Button className="self-stretch" onClick={handleContactClick}>
          Написать
        </Button>
      </YStack>
    </BottomSheet>
  );
};
